import type { Primitive } from 'type-fest'

/**
 * NOTE: These statically referenced, and as such will not rerender when changed
 */
export default {
	SUPPORT_LINK: 'https://support.auk.com',
	DEV_EMAIL: 'dev@auk.com'
} as Record<string, Primitive>
